module.exports = ".container{\r\n  margin:0;\r\n  padding:0;\r\n  background-color: #eee;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main